<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  '唛头文本/关联目的港口/关联客户 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_shippingMarkText') || '唛头文本'"
            >
              <el-input
                v-model.trim="form.shippingMarkText"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_shippingMarkType') || '唛头类型'"
            >
              <el-select
                v-model="form.listShippingMarkType"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                multiple
                filterable
                clearable
                style="width:100%"
              >
                <el-option
                  value="T"
                  :label="$l('form_label_shippingMarkType_text') || '文本'"
                ></el-option>
                <el-option
                  value="I"
                  :label="$l('form_label_shippingMarkType_image') || '图片'"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_destinationPort') || '关联目的港口'"
            >
              <dict-select
                v-model="form.listDestinationPort"
                url="/master/port/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                multiple
                filterable
                clearable
                style="width:100%"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '关联客户'">
              <dict-select
                url="/master/common/dict/customerSelect"
                v-model="form.listCustCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reload">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
